<template>
  <v-card-text>
    <v-card-row>
      <h5 class="subheading">{{ $t('feedbackcontent.by') }} {{ feedback.rater.nickname }}</h5>
      <v-spacer></v-spacer>
      <h6 class="subheading">{{ $t('feedbackcontent.date') }} <date :value="feedback.created_at"></date></h6>
    </v-card-row>
    <p v-html="feedback.content"></p>
    <blockquote class="pa-2 pl-3" v-if="feedback.response" v-html="feedback.response"></blockquote>
  </v-card-text>
</template>

<script>
  import { Date } from '@/components/formatters'
  export default {
    components: {
      Date
    },
    props: {
      feedback: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped>
  blockquote {
    border-width: 3px;
    font-size: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/FeedbackContent.vue